import { useQuery } from '@tanstack/react-query';
import { modulesApi, moduleKeys } from '@/lib/api';

export function useModules() {
  return useQuery({
    queryKey: moduleKeys.lists(),
    queryFn: () => modulesApi.list(),
    staleTime: 5 * 60 * 1000, // 5 minutes - modules don't change often
  });
}
